import { createFilteredUrlParams } from "../utils/createFilteredUrlParams";
import { ProductsListParams } from "../../shared/types/products";

const productsETLEndpoint = "/api/etl/products/list";

const ENDPOINTS = {
  productsETL: (params: ProductsListParams) =>
    `${productsETLEndpoint}?${createFilteredUrlParams<ProductsListParams>(params)}`,
};
export { ENDPOINTS };
